import React from 'react'
import { Button, Modal, Select, Tooltip } from 'antd'
import { CloseOutlined, FormOutlined } from "@ant-design/icons";



const AccessFilterModal = ({visible, closemodal ,applications, selectedApps, 
  handleApply, HandleAppSelect, handleCancel, handleReset, HandleRemoveSelect,
   Approles ,handleRoleSelect ,handleRemoveRole, selectedRoles}) => {

  return (
    <Modal title={<p className="modal-heading">FILTER APPLICATIONS</p>}
    open={visible}
    footer={null}
    width={600}
    onCancel={closemodal}
    onOk={handleApply}
    >

        <div
            style={{
              display: "flex",
              alignItems: "center",
              padding: "1rem",
              width : "60rem"
            }}
          >
            <Tooltip >
            <p className="my-form-lables" style={{width : "20rem"}}>Select Applications</p>
            </Tooltip>
            <Select
              showSearch
              placeholder="Select Applications"
              className="my-form-input"
              onSelect={HandleAppSelect}
              onDeselect={HandleRemoveSelect}
              value={selectedApps}
              mode='multiple'
              style={{
                width : "30rem",
                marginLeft: "1rem",
                borderRadius: "0.7rem",
                borderColor: "#818589",
              }}
            >
            {applications?.map((naics) => (
            <Select.Option key={naics.id} value={naics.id}>
              {`${naics.name}`}
            </Select.Option>
          ))}
            </Select>
          </div>


          <div
            style={{
              display: "flex",
              alignItems: "center",
              padding: "1rem",
              width : "60rem"
            }}
          >
            <Tooltip >
            <p className="my-form-lables" style={{width : "20rem"}}>Select Role</p>
            </Tooltip>
            <Select
              showSearch
              placeholder="All"
              className="my-form-input"
              onSelect={handleRoleSelect}
              onDeselect={handleRemoveRole}
              value={selectedRoles}
              disabled={selectedApps.length < 1 ? true : false}
              mode='multiple'
              style={{
                width : "30rem",
                marginLeft: "1rem",
                borderRadius: "0.7rem",
                borderColor: "#818589",
              }}
            >
            {Approles?.map((role) => (
            <Select.Option key={role.role_id} value={role.id}>
              {`${role.name}`}
            </Select.Option>
          ))}
            </Select>
          </div>

          
        <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          height: "2rem",
          marginTop: "1rem",
          marginBottom: "1rem",
        }}
      >
        <Button key="back"  onClick={handleCancel}>
          <CloseOutlined />
          Cancel
        </Button>
        <Button
          type="primary"
          style={{ marginLeft: "1rem" }}
          onClick={handleReset}
        >
          {/* <CloseOutlined /> */}
          Reset
        </Button>
        <Button
          type="primary"
          htmlType="submit"
          style={{
            background: "#f58029",
            fontWeight: "600",
            marginLeft: "1rem",
          }}
          className="save-update-btn"
          onClick={handleApply}
        >
          Apply
          <FormOutlined />
        </Button>
      </div>
    </Modal>
  )
}

export default AccessFilterModal